export default "__VITE_ASSET__B7W6N0EE__"